"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _services = require("../../../services");
var _r10SourceLibrary = require("r10-source-library");
var _constants = require("../../../utils/constants");
var _SelectInput = _interopRequireDefault(require("./SelectInput"));
var _templateObject, _templateObject2;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
var CenteringWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var DiscountedPrice = _styledComponents.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  min-height: 26px;\n"])));
var PlanCardContent = function PlanCardContent(_ref) {
  var setSelectedProduct = _ref.setSelectedProduct,
    selectOptions = _ref.selectOptions,
    selectedProduct = _ref.selectedProduct,
    onSelect = _ref.onSelect;
  var paymentOption = selectedProduct.paymentOption,
    productId = selectedProduct.productId;
  var paymentTermText = (paymentOption === null || paymentOption === void 0 ? void 0 : paymentOption.priceType) === _constants.PRICE_TYPES.RECURRING ? _services.locale.localeString("Comparison.".concat(paymentOption === null || paymentOption === void 0 ? void 0 : paymentOption.term.unit)) : '';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 3,
      bottom: 3
    }
  }, /*#__PURE__*/_react.default.createElement(_SelectInput.default, {
    productId: productId,
    selectOptions: selectOptions,
    onChangeHandle: setSelectedProduct
  })))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(CenteringWrapper, null, (paymentOption === null || paymentOption === void 0 ? void 0 : paymentOption.price) && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      bottom: 3
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, {
    size: 2,
    weight: 3
  }, "".concat(paymentOption.price, " ").concat(paymentTermText))))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(DiscountedPrice, null, (paymentOption === null || paymentOption === void 0 ? void 0 : paymentOption.previousPrice) && /*#__PURE__*/_react.default.createElement("span", {
    style: {
      color: '#0D0D0D',
      textDecoration: 'line-through'
    }
  }, "".concat(paymentOption.previousPrice, " ").concat(paymentTermText)))))))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridColumn, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 3,
      bottom: 3
    }
  }, /*#__PURE__*/_react.default.createElement(CenteringWrapper, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Button, {
    appearance: "secondary",
    text: _services.locale.localeString('Comparison.PlanButtonText'),
    width: "full",
    onClick: function onClick() {
      onSelect(productId);
    }
  }))))), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    justify: "center",
    marginTop: 2
  }, /*#__PURE__*/_react.default.createElement(DiscountedPrice, null, paymentOption.term.duration && /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Paragraph, null, _services.locale.localeString('Comparison.For'), " ", paymentOption.term.duration, ' ', _services.locale.localeString('Comparison.Months')))));
};
var _default = PlanCardContent;
exports.default = _default;